import { useEffect, useState } from "react";
import type {
  EmblaCarouselType,
  EmblaOptionsType,
  EmblaPluginType,
  UseEmblaCarouselType,
} from "types/vendor/embla-carousel";

export default function useEmblaCarousel(
  options?: EmblaOptionsType,
  plugins?: EmblaPluginType[],
): UseEmblaCarouselType {
  const [root, setRoot] = useState<HTMLElement | null>(null);
  const [emblaApi, setEmblaApi] = useState<EmblaCarouselType>();

  useEffect(() => {
    if (!window.EmblaCarousel) {
      console.error("EmblaCarousel not found on window.");
      return;
    }
    if (!root) return;

    const embla = window.EmblaCarousel(root, options, plugins);
    setEmblaApi(embla);

    return () => {
      embla?.destroy();
      setEmblaApi(undefined);
    };
  }, [root]);

  return [setRoot, emblaApi];
}
